
export function getSingleFee(envelope: any, ticket: any) {
    return +envelope.otherFees > 0 ? +ticket.fee + envelope.otherFees / envelope.tickets.length : +ticket.fee;
}